module.exports = "/_next/static/images/pricing-plans-consulting-header-4a3af1fc35dbcc505cc605ca527b94bc.webp";